import { Drawer, Button, message, Form, Input, Select, Space } from 'antd';
import {AdminRoleTemplateApi} from "gmrfid-service-user-api-manager"
import { DrawerStyle } from './style';
import React from 'react';

const { Option } = Select;

const Add = ({ setShowDrawer, showDrawer, tableObj, setTableTime, setTableObj, mode, setFields }) => {
  const [form] = Form.useForm();

  const onClose = () => {
    setShowDrawer(false);
    setTableObj({});
  };

  const onFinish = (values) => {
    const par = {
      id: tableObj?.id,
      ...values,
    };
    AdminRoleTemplateApi.save({
      form: par,
    }).then((res) => {
      if (res && res.status === 200) {
        message.success('操作成功');
        setTableTime(Math.random());
        setFields({ platforms: values.platforms?.join(',') || null });
        onClose();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  React.useEffect(() => {
    if (tableObj?.id) {
      form.setFieldsValue({
        name: tableObj?.name,
        platforms: tableObj?.platforms,
      });
    }
  }, [form, tableObj]);

  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={showDrawer}
      className="drawerModal"
      destroyOnClose
      width={720}
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            {tableObj?.id ? '编辑套餐' : '新增套餐'}
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <div className="drawer-content">
          <Form name="basic" layout="vertical" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <Form.Item
              label="套餐名称"
              name="name"
              rules={[
                {
                  required: true,
                  message: '请输入套餐名称',
                },
                {
                  message: '请输入20字以内的套餐名称',
                  max: 20,
                },
              ]}
              wrapperCol={{ span: 16 }}
            >
              <Input allowClear placeholder="请输入" />
            </Form.Item>
            <Form.Item
              label="应用端"
              name="platforms"
              rules={[
                {
                  required: true,
                  message: '请选择',
                },
              ]}
              wrapperCol={{ span: 16 }}
            >
              <Select mode="multiple" maxTagCount="responsive" allowClear placeholder="请选择平台">
                <Option value="MANAGER">物业端（WEB）</Option>
                <Option value="MANAGER_SUPERVISE">行业端（WEB）</Option>
                <Option value="MANAGER_SERVICE">服务商（WEB）</Option>
                <Option value="SERV">服务人员（小程序）</Option>
                <Option value="JMH">家美慧（小程序）</Option>
                <Option value="MINI_PROPERTY">物业管理（小程序）</Option>
                <Option value="MINI_SUPERVISE">行业管理（小程序）</Option>
                <Option value="ADMIN_MANAGER">总后台</Option>
                <Option value="COMPANY">企业管理</Option>
                <Option value="AUTONOMOUS">筹备组/自治组织</Option>
              </Select>
            </Form.Item>
          </Form>
        </div>
        <Space style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }} size={20}>
          <Button onClick={onClose}>
            取消
          </Button>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
          >
            保存
          </Button>
        </Space>
      </DrawerStyle>
    </Drawer>
  );
};
export default Add;
